import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { ApplicationRef, inject } from '@angular/core';
import { finalize, tap } from 'rxjs';

let renderScheduled = false;

/**
 * Manual subscriptions across the admin mutate component fields directly.
 * Angular's zoneless runtime does not always schedule a view refresh for those
 * mutations, so notify the application once per completed HTTP microtask.
 */
export const renderInterceptor: HttpInterceptorFn = (request, next) => {
  const application = inject(ApplicationRef);
  const scheduleRender = (): void => {
    if (renderScheduled || application.destroyed) return;
    renderScheduled = true;
    // Use the next browser task so component-level `finalize` handlers have
    // completed before the shared render pass runs. This prevents a completed
    // request from leaving stale loading text on zoneless pages.
    setTimeout(() => {
      renderScheduled = false;
      if (!application.destroyed) application.tick();
    }, 0);
  };

  return next(request).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) scheduleRender();
    }),
    finalize(scheduleRender),
  );
};
